import { render, staticRenderFns } from "./FollowedTabs.vue?vue&type=template&id=5620e1c1"
import script from "./FollowedTabs.vue?vue&type=script&lang=js"
export * from "./FollowedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports